// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

// SPA navigation is invisible to screen readers by default: the page changes
// but focus stays on the old element and nothing is announced (WCAG 2.4.3 /
// 4.1.3). On every route change this moves focus to the #main landmark and
// announces the new location via a polite live region. Page titles are owned
// by the pages themselves (LegalShell, login) or PharmacyContext.
export default function RouteFocusAnnouncer() {
  const { pathname } = useLocation()
  const live = useRef<HTMLDivElement>(null)
  const first = useRef(true)

  useEffect(() => {
    if (first.current) { first.current = false; return } // don't steal focus on initial load
    const main = document.getElementById('main')
    if (main) main.focus({ preventScroll: false })
    const seg = pathname.split('/').filter(Boolean).pop() ?? 'home'
    const label = seg.replace(/[-_]/g, ' ')
    if (live.current) live.current.textContent = `Navigated to ${label}`
  }, [pathname])

  return (
    <div
      ref={live}
      role="status"
      aria-live="polite"
      style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0 0 0 0)', whiteSpace: 'nowrap' }}
    />
  )
}
